//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
const statusList = {
  0: '正常',
  1: '删除',
  Creating: '函数创建中',
  CreateFailed: '函数创建失败（如果已生成函数信息，则可以删除后再创建）',
  Active: '函数可用',
  Updating: '函数更新中',
  UpdateFailed: '函数更新失败',
  Publishing: '函数版本发布中',
  PublishFailed: '函数版本发布失败',
  Deleting: '函数删除中',
  DeleteFailed: '函数删除失败',
};
export default {
  data() {
    return {
      statusList,
      id: '',
      title: '选择云函数自定义事件',
      cloudFunId: '',
      basicInfo: {
        name: '',
        keys: [],
        event_key: '',
        cloud_func_name: '',
        remark: '',
      },
      paramsInfo: {
        params: [
          {
            source: '',
            name: '',
            type: '',
          },
        ],
        options: [],
      },
      processKeyList: [],
      dialogVisible: false,
      cloudFunList: [],
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      func_name: '',
      currentRow: null,
      // 记录列表页状态
      eventTypes: '',
      statusTab: '',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']), // user 模块名称
    jurisdiction() {
      const jurisdictionArray = ['eventManage_workflow_editCloudFunction'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
  },
  created() {
    const { id, statusTab, eventTypes } = this.$route.query;
    this.id = id;
    this.statusTab = statusTab;
    this.eventTypes = eventTypes;
    if (id) {
      this.getProcessActionDetail(id);
    }
  },
  methods: {
    addParamsItem(index) {
      this.paramsInfo.params.splice(index + 1, 0, {
        source: '',
        name: '',
        type: '',
      });
    },
    deleteParamsItem(index) {
      this.paramsInfo.params.splice(index, 1);
    },
    loadMoreFunList() {
      if (this.cloudFunList.length >= this.total) {
        return;
      }
      this.pageIndex += 1;
      this.getCloudFuncList();
    },
    searchCloudFunList() {
      this.pageSize = 10;
      this.pageIndex = 1;
      this.cloudFunList = [];
      this.getCloudFuncList();
    },
    getCloudFuncList() {
      this.$request({
        url: this.$api.getFuncList,
        data: {
          page: this.pageIndex - 1,
          size: this.pageSize,
          search_key: this.func_name,
        },
        showLoading: false,
        cb: ({ list, total }) => {
          this.cloudFunList = [
            ...this.cloudFunList,
            ...list?.filter((item) => item.func_type === 0 || item.func_type === 4),
          ];
          this.total = Number(total);
        },
      });
    },
    openTableDiaLog(e) {
      e.preventDefault();
      this.dialogVisible = true;
      this.func_name = '';
      this.getCloudFuncList();
    },
    buttonOpenDia() {
      this.dialogVisible = true;
      this.func_name = '';
      this.getCloudFuncList();
    },
    getProcessActionDetail(id) {
      this.$request({
        url: this.$api.getProcessActionById,
        data: { id },
        cb: ({ process }) => {
          if (process) {
            const { name, remark, template, keys, event_key } = process;
            this.basicInfo = {
              name,
              remark,
              keys,
              cloud_func_name: template.cloud_func.name,
              event_key,
            };
            this.paramsInfo.params = template.cloud_func.params.length
              ? template.cloud_func.params
              : [
                  {
                    source: '',
                    name: '',
                    type: '',
                  },
                ];
            if (template.cloud_func.name) {
              this.$request({
                url: this.$api.getFuncList,
                data: {
                  page: 0,
                  size: 1,
                  search_key: template.cloud_func.name,
                },
                showLoading: false,
                cb: ({ list }) => {
                  const paramsInfo = list[0].param_in;
                  try {
                    if (paramsInfo) {
                      const paramsList = JSON.parse(paramsInfo).properties;
                      this.paramsInfo.options = Object.keys(paramsList).map((key) => ({
                        value: key,
                        label: key,
                        type: paramsList[key].type,
                      }));
                    }
                  } catch (err) {
                    console.error('errr', err);
                  }
                },
              });
            }
          }
        },
      });
    },
    goBack() {
      this.$router.push({
        name: 'workflow-event-list',
        query: {
          statusTab: this.statusTab,
          eventTypes: this.eventTypes,
        },
      });
    },
    submitCloudDetail() {
      this.$refs.basicForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const detailData = {
          category: 2, // 1是通知事件， 2是云函数
          name: this.basicInfo.name,
          remark: this.basicInfo.remark,
          event_key: this.basicInfo.event_key,
          status: 1,
          template: {
            cloudFunc: {
              name: this.basicInfo.cloud_func_name,
              params: this.paramsInfo.params.map((item) => {
                const paramType =
                  this.paramsInfo.options?.find((opt) => opt.value === item.name)?.type || '';
                return {
                  ...item,
                  type: paramType,
                };
              }),
            },
          },
        };
        if (!this.id) {
          this.createEvent(detailData);
        } else {
          delete detailData.status;
          this.updateEvent({
            id: this.id,
            ...detailData,
          });
        }
      });
    },
    createEvent(data) {
      this.$request({
        url: this.$api.createProcessAction,
        data,
        cb: (resdata) => {
          if (resdata.id) {
            this.$message.success('提交成功');
            this.goBack();
          }
        },
      });
    },
    updateEvent(data) {
      this.$request({
        url: this.$api.updateProcessAction,
        data,
        cb: (resdata) => {
          if (resdata) {
            this.$message.success('提交成功');
            this.goBack();
          }
        },
      });
    },
    handleSelectChange(val) {
      this.currentRow = val;
    },
    setCloudFunName() {
      if (this.currentRow) {
        const { func_name, id, param_in } = this.currentRow;
        console.log('func_name', func_name);
        this.basicInfo.cloud_func_name = func_name;
        try {
          if (param_in) {
            const paramsList = JSON.parse(param_in).properties;
            this.paramsInfo.options = Object.keys(paramsList).map((key) => ({
              value: key,
              label: key,
              type: paramsList[key].type,
            }));
          }
        } catch (err) {
          console.error('errr', err);
        }
        if (this.cloudFunId !== id) {
          this.paramsInfo.params = [
            {
              source: '',
              name: '',
              type: '',
            },
          ];
        }
        this.cloudFunId = id;
      }
      this.dialogVisible = false;
    },
  },
};
